document.addEventListener("DOMContentLoaded", () => {
    const modal = document.getElementById('timeModal');
    const preview = document.getElementById('HCModalPreview');
    const confirmBtn = document.getElementById('HCConfirmBtn');
    const timeDisplays = document.querySelectorAll('.js-time-display');

    if (!timeDisplays.length) return;

    let selected = { sign: 1, d: 0, h: 0, m: 0 };

    function lockBodyScroll() {
        document.body.style.overflow = 'hidden';
    }

    function unlockBodyScroll() {
        document.body.style.overflow = '';
    }

    function updatePreview() {
        const signSymbol = selected.sign === 1 ? '' : '- ';
        preview.textContent = `${signSymbol}${selected.d}д ${selected.h}ч ${selected.m}м`;
    }

    function updateDisplay() {
        const $timeDisplay = $(modal).data('timeDisplay');

        // Обновляем знак
        $timeDisplay.find('.js-time-display-sign').text(selected.sign === 1 ? '' : '-');
        $timeDisplay.find('.js-time-display-days').text(selected.d + 'д');
        $timeDisplay.find('.js-time-display-hours').text(selected.h + 'ч');
        $timeDisplay.find('.js-time-display-mins').text(selected.m + 'м');

        // скрыть / показать знак
        if(selected.sign === 1) {
            $timeDisplay.find('.time-display__item').eq(0).addClass('tw:hidden');
        }else{
            $timeDisplay.find('.time-display__item').eq(0).removeClass('tw:hidden');
        }

        const signText = selected.sign === 1 ? '' : '- ';
        $timeDisplay.prev().val(`${signText}${selected.d}д ${selected.h}ч ${selected.m}м`);
    }

    /* будем собирать инициализаторы колонок, чтобы вызывать их при открытии модалки */
    const colInits = [];

    function bindColumn(columnId, key) {
        const colWrap = document.getElementById(columnId);
        if (!colWrap) return;
        const scrollEl = colWrap.querySelector('.HC-modal__col-scroll');
        if (!scrollEl) return;

        let scrollTimeout = null;

        function centerNearest() {
            const items = Array.from(scrollEl.querySelectorAll('.HC-modal__item'));
            if (!items.length) return;

            const colCenter = scrollEl.scrollTop + scrollEl.clientHeight / 2;

            let closest = null;
            let minDiff = Infinity;
            items.forEach(item => {
                const center = item.offsetTop + item.offsetHeight / 2;
                const diff = Math.abs(center - colCenter);
                if (diff < minDiff) {
                    minDiff = diff;
                    closest = item;
                }
            });

            if (!closest) return;

            items.forEach(i => i.classList.remove('active'));
            closest.classList.add('active');

            // Для знака сохраняем как число, для остальных как есть
            if (key === 'sign') {
                selected.sign = parseInt(closest.dataset.value);
            } else {
                selected[key] = closest.dataset.value;
            }

            updatePreview();

            const maxDistance = scrollEl.clientHeight / 2;
            items.forEach(item => {
                const center = item.offsetTop + item.offsetHeight / 2;
                const dist = Math.abs(center - colCenter);
                const ratio = Math.max(0, 1 - dist / maxDistance);
                const scale = 0.92 + ratio * 0.14;
                const opacity = 0.4 + ratio * 0.7;
                item.style.transform = `scale(${scale})`;
                item.style.opacity = Math.min(1, opacity);
                if (ratio > 0.9) {
                    item.style.background = 'rgba(255,255,255,0.98)';
                    item.style.borderRadius = '8px';
                } else {
                    item.style.background = 'transparent';
                    item.style.borderRadius = '';
                }
            });
        }

        scrollEl.addEventListener('click', (e) => {
            const item = e.target.closest('.HC-modal__item');
            if (item) item.scrollIntoView({behavior: 'smooth', block: 'center'});
        });

        scrollEl.addEventListener('scroll', () => {
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(centerNearest, 80);
        }, {passive: true});

        const init = () => {
            const items = Array.from(scrollEl.querySelectorAll('.HC-modal__item'));
            if (!items.length) return;

            let start;
            if (key === 'sign') {
                start = items.find(i => parseInt(i.dataset.value) === selected.sign) || items[0];
            } else {
                start = items.find(i => parseInt(i.dataset.value) === parseInt(selected[key])) || items[0];
            }

            // Принудительно устанавливаем active для знака
            if (key === 'sign') {
                items.forEach(i => i.classList.remove('active'));
                if (start) start.classList.add('active');
            }

            start.scrollIntoView({behavior: 'auto', block: 'center'});
            setTimeout(centerNearest, 50);
        };

        colInits.push(init);
    }

    function initTimeModal($timeDisplay) {
        // Сбрасываем инициализаторы
        colInits.length = 0;

        // Инициализируем selected из данных
        const signText = $timeDisplay.find('.js-time-display-sign').text().trim();
        selected = {
            sign: signText === '-' ? -1 : 1,
            d: parseInt($timeDisplay.find('.js-time-display-days').text()) || 0,
            h: parseInt($timeDisplay.find('.js-time-display-hours').text()) || 0,
            m: parseInt($timeDisplay.find('.js-time-display-mins').text()) || 0
        };

        // Привязываем колонки
        bindColumn("signColumn", "sign");
        bindColumn("daysColumn", "d");
        bindColumn("hoursColumn", "h");
        bindColumn("minsColumn", "m");

        modal.style.display = 'flex';

        // Инициализируем
        colInits.forEach(fn => fn());

        // Принудительно обновляем превью
        updatePreview();

        $(modal).data('timeDisplay', $timeDisplay);
    }

    /* открыть модалку */
    timeDisplays.forEach(timeDisplay => {
        timeDisplay.addEventListener('click', function(e) {
            const $timeDisplay = $(this).closest('.js-time-display');
            if (!$timeDisplay.length || $timeDisplay.attr('data-disabled') === 'true') return;

            initTimeModal($timeDisplay);
            updatePreview();
            lockBodyScroll();
        });
    });

    /* подтвердить */
    confirmBtn.addEventListener('click', () => {
        updateDisplay();
        modal.style.display = 'none';
        unlockBodyScroll();
    });
});
